import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { env } from "../utils/env";

export const useResetPassword = () => {
  return useMutation(({ email }: { email: string }) => {
    return axios.post(`${env.verifyServiceUrl}user/forgot_password/`, {
      email,
    });
  });
};
